//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Get qualifications
 * @param participant (optional) 
 * @param description (optional) 
 * @param isValid (optional) 
 * @param isExpireSoon (optional) 
 * @param isExpired (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function get(participant?: string | null | undefined, description?: string | null | undefined, isValid?: boolean | undefined, isExpireSoon?: boolean | undefined, isExpired?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfQualificationResponseDto> {
    let url_ = getBaseUrl() + "/api/qualifications?";
    if (participant !== undefined && participant !== null)
        url_ += "Participant=" + encodeURIComponent("" + participant) + "&";
    if (description !== undefined && description !== null)
        url_ += "Description=" + encodeURIComponent("" + description) + "&";
    if (isValid === null)
        throw new Error("The parameter 'isValid' cannot be null.");
    else if (isValid !== undefined)
        url_ += "IsValid=" + encodeURIComponent("" + isValid) + "&";
    if (isExpireSoon === null)
        throw new Error("The parameter 'isExpireSoon' cannot be null.");
    else if (isExpireSoon !== undefined)
        url_ += "IsExpireSoon=" + encodeURIComponent("" + isExpireSoon) + "&";
    if (isExpired === null)
        throw new Error("The parameter 'isExpired' cannot be null.");
    else if (isExpired !== undefined)
        url_ += "IsExpired=" + encodeURIComponent("" + isExpired) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.PagedResultOfQualificationResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPagedResultOfQualificationResponseDto(resultData200);
        return Promise.resolve<Types.PagedResultOfQualificationResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfQualificationResponseDto>(null as any);
}

/**
 * Update qualifications
 * @param executeJobFrom (optional) If specified, fetches qualifications updated after this date.
            Otherwise, the latest UpdatedAt from the database is used.
 * @param dryRun (optional) If true, fetched qualifications will not be persisted to the database.
 */
export function syncQualifications(executeJobFrom?: Date | null | undefined, dryRun?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/qualifications/update?";
    if (executeJobFrom !== undefined && executeJobFrom !== null)
        url_ += "executeJobFrom=" + encodeURIComponent(executeJobFrom ? "" + executeJobFrom.toISOString() : "") + "&";
    if (dryRun === null)
        throw new Error("The parameter 'dryRun' cannot be null.");
    else if (dryRun !== undefined)
        url_ += "dryRun=" + encodeURIComponent("" + dryRun) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSyncQualifications,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSyncQualifications?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSyncQualifications(_response);
    });
}

function processSyncQualifications(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Sends qualification emails and updates qualification notification dates.
 */
export function notifyAndUpdateQualifications(settings: Types.QualificationNotificatorJobSettings, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/qualifications/notify-and-update";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(settings);

    let options_: AxiosRequestConfig = {
        ..._requestConfigNotifyAndUpdateQualifications,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigNotifyAndUpdateQualifications?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processNotifyAndUpdateQualifications(_response);
    });
}

function processNotifyAndUpdateQualifications(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigSyncQualifications: Partial<AxiosRequestConfig> | null;
export function getSyncQualificationsRequestConfig() {
  return _requestConfigSyncQualifications;
}
export function setSyncQualificationsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSyncQualifications = value;
}
export function patchSyncQualificationsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSyncQualifications = patch(_requestConfigSyncQualifications ?? {});
}

let _requestConfigNotifyAndUpdateQualifications: Partial<AxiosRequestConfig> | null;
export function getNotifyAndUpdateQualificationsRequestConfig() {
  return _requestConfigNotifyAndUpdateQualifications;
}
export function setNotifyAndUpdateQualificationsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigNotifyAndUpdateQualifications = value;
}
export function patchNotifyAndUpdateQualificationsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigNotifyAndUpdateQualifications = patch(_requestConfigNotifyAndUpdateQualifications ?? {});
}